import React from 'react';

class DisplayButton extends React.Component {
  render() {
    return (
      <div className={this.props.button.buttonName}>
        <img src={this.props.button.maskImg} alt="buttonMask" className={this.props.button.maskName} style={{backgroundColor: this.props.button.lightState}}/>
        <img src={this.props.button.rayImg} alt="ray" className={this.props.button.rayName} style={{opacity: this.props.button.rayState}}/>
        <img src={this.props.button.baseImg} alt="base" className={this.props.button.baseName}/>
      </div>
    )
  }
}

export default DisplayButton;



// WEBPACK FOOTER //
// ./src/Components/DisplayButton/DisplayButton.js